import type { RatingSummary } from '@spot/shared';
import { useTranslation } from 'react-i18next';

/** «★ 4.8 · 12» (T-905). Renders nothing when the API sends null (below 3 reviews, D13). */
export function RatingBadge({
	rating,
	kind = 'event',
	className = '',
}: {
	rating: RatingSummary;
	/** Which rating it is, for screen readers. */
	kind?: 'event' | 'organizer';
	className?: string;
}) {
	const { t, i18n } = useTranslation();
	if (rating === null) return null;
	const average = new Intl.NumberFormat(i18n.language, {
		minimumFractionDigits: 1,
		maximumFractionDigits: 1,
	}).format(rating.average);
	const label = t(
		kind === 'organizer' ? 'reviews.organizer_rating_label' : 'reviews.rating_label',
		{
			average,
			count: rating.count,
		},
	);
	return (
		<span
			role="img"
			aria-label={label}
			className={`text-caption text-text-muted inline-flex items-center gap-1 whitespace-nowrap ${className}`}
		>
			<span aria-hidden="true" className="text-primary">
				★
			</span>
			<span aria-hidden="true">
				{average} · {rating.count}
			</span>
		</span>
	);
}
